let token = 'ELSA1+xKobD7gfskZ6g12ge3OJbtJ%2BE5rzCEi9W%2FYi9b0jvGTzZ5kuPtycc5PS75IXtxW2';
let prod_token = 'vsO9lqaLcPAbqIobzEeOjaiX_-aiDNh1';
let url_speech = `wss://pool.elsanow.io/api/v2/website?Authorization=${token}`;
VueNativeSock = VueNativeSock.default;
Vue.use(VueNativeSock, url_speech, {
  connectManually: true,
  format: 'json',
  reconnection: true, // (Boolean) whether to reconnect automatically (false)
  reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
  reconnectionDelay: 1000, // (Number) how long to initially wait before attempting a new (1000)
});
const vm = new Vue();
var socket = new Vue({
  methods: {
    isOpen: function () {
      return this.$socket.WebSocket.readyState === this.$socket.WebSocket.OPEN
    },
    connectWebsocket: function () {
      // vm.$connect();
    },

    initWebsocket: function (sentence) {
      const messageInit = {
        "type": "ELSA:start_stream",
        "data": {
          "sampling_rate": 16000,
          "stream_type": "pronunciation_exercise",
          "stream_info": {
            "sentence": sentence.text,
            "sentence_hash": sentence.hash
          }
        }
      };
      this.$socket.sendObj(messageInit);
    },

    sendAudio: function (transcript) {
      Vue.prototype.$socket.send(transcript);
    },

    finishRecord: function () {
      const message = {
        "type": "ELSA:last_packet"
      };
      this.$socket.sendObj(message);
    },

    disconnectSocket: function () {
      // vm.$disconnect();
    }
  }
});

let gumStream;
let rec;
let input;
let currentRecordBlob = [];
let AudioContext = window.AudioContext || window.webkitAudioContext || false;
Object.defineProperty(Vue.prototype, `$SOCKET`, {
  get() {
    return socket;
  }
});
/////////////////////////////////////////// speech ///////////////////////////////////////
Vue.component('ElsaSpeech', {
  template: `
            <div @click="recording" style="width:100%; height:100%;z-index=999">
            </div>
            `,
  data() {
    return {
      audioContext: false,
      canTest: false,
      sendData: '',
      loading: false,
      resultTest: {},
    }
  },
  mounted() {
    if (this.supported()) {
      this.canTest = true;
    }
    this.$options.sockets.onmessage = (data) => {
      data = JSON.parse(data.data);
      console.log(data);
      this.processResponseWebSocket(data);
    };
  },
  props: ['input', 'isActive'],
  methods: {
    supported() {
      return (window.AudioContext !== undefined || window.webkitAudioContext !== undefined) &&
        navigator.mediaDevices &&
        navigator.mediaDevices.getUserMedia;
    },
    processResponseWebSocket(data) {
      if (data.type === 'ELSA:decoding_result') {
        this.severStopRecording();
        this.resultTest = data.data;
        this.emitResult();
      } else if (data.type === 'ELSA:server_closing') {
        this.resultTest = {
          error: 'server_closing'
        };
        this.emitResult();
      }
      //data.type === 'ELSA:error'?
    },
    initRecording() {
      this.$SOCKET.initWebsocket(this.input);
      this.canTest = true;
    },
    recordStreaming() {
      const vm = this;
      rec && rec.exportWAV(function (blob) {
        currentRecordBlob.push(blob);
        if (vm.$SOCKET.isOpen()) {
          vm.$SOCKET.sendAudio(blob);
          rec.clear();
        } else {
          console.log('socket close!')
          vm.severStopRecording();
          vm.resultTest = {
            error: 'server_closing'
          };
          vm.emitResult();
        }
      });
    },
    startRecording() {
      console.log('startRecording');
      if (this.canTest) {
        const constraints = {
          audio: true,
          video: false
        };
        const that = this;
        navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
          that.audioContext = new AudioContext();
          gumStream = stream;
          input = that.audioContext.createMediaStreamSource(stream);
          rec = new Recorder(input, {
            numChannels: 1
          })
          rec.record();
          that.initRecording();
        }).catch(function (err) {
          console.log(err);
        });
        this.sendData = setInterval(this.recordStreaming, 2000);
      } else {
        alert('Microphone not supported. Make sure you are using a browser that allows microphone recording. (Safari for iPhone/IPad, Chrome/Firefox for Android)')
      }
    },
    userStopRecord() {
      this.$SOCKET.finishRecord();
      rec && rec.stop();
      gumStream && gumStream.getAudioTracks()[0].stop();
      this.recordStreaming();
      this.loading = true;
      rec.clear();
      clearInterval(this.sendData);
    },
    severStopRecording() {
      this.$SOCKET.disconnectSocket();
      clearInterval(this.sendData);
      rec && rec.stop();
      gumStream && gumStream.getAudioTracks()[0].stop();
      this.loading = false;
      rec.clear();
    },
    recording: function () {
      if (this.isActive) {
        this.$emit('start', {});
        this.startRecording();
      }
    },
    submit: function () {
      this.userStopRecord();
    },
    emitResult: function () {
      this.$emit('result', {
        score: this.resultTest
      });
      this.resultTest = {};
    }
  }
});
/////////////////////////////////////////// data ///////////////////////////////////////
// var instruction = new Vue({
//   el: '#instruction',
//   data: {
//     message: 'https://d1t11jpd823i7r.cloudfront.net/favicon/favicon.ico'
//   }
// });
var sentences = [{
  text: 'This summer I will visit a new country with two of my best friends',
  hash: '9d04f4a4bc5b420616c5b0df180b8b4219c87a07e8348fad093c0ddabed8d48b',
  audio_url: 'https://d1t11jpd823i7r.cloudfront.net/assessment/audio/general_01.mp3',
  audio: null,
}, {
  text: 'We will go sightseeing and stay at a resort by the ocean',
  hash: '0136951c3017585dd152790a772682b53749830474ca8d33fb4d0de406b155df',
  audio_url: 'https://d1t11jpd823i7r.cloudfront.net/assessment/audio/general_02.mp3',
  audio: null,
}, {
  text: 'We will get to enjoy a nice room with a beautiful view of the ocean',
  hash: 'a65afb8118966d627e6f4e354ebc17a0d74c0e941a76323ff68815a73ebc2003',
  audio_url: 'https://d1t11jpd823i7r.cloudfront.net/assessment/audio/3-We_will_get.mp3',
  audio: null,
},]
/////////////////////////////////////////// tracking ///////////////////////////////////////
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
var client_id = '';
var cookie_id = getCookie('assessment_session');
var cookieExdays = 365;
var saveAction = function (sentence, sentence_id, score, score_detail, user_info, action) {
  var url = '/api/assessment/action'
  var json_data = {
    client_id: client_id,
    cookie_id: cookie_id,
    test_id: '1',
    sentence_id: sentence_id,
    sentence: sentence,
    score: score,
    score_detail: JSON.stringify(score_detail),
    user_info: user_info,
    action: action
  }
  var xhr = $.ajax({
    async: false,
    type: "POST",
    url: url,
    data: json_data,
    success: function (data, status) {
      console.log(data);
      if (status == 'success') {
        if (client_id == '') {
          client_id = client_id || data.client_id || '';
          if (client_id) setCookie('assessment_id', client_id, cookieExdays);
        }
        if (cookie_id == '') {
          cookie_id = cookie_id || data.client_id || '';
          if (cookie_id) setCookie('assessment_session', cookie_id, cookieExdays);
        }
      }
    }
  })
    .done(function () {
      console.log('Request done!');
    })
    .fail(function (jqxhr, settings, ex) {
      console.log('fail' + ex);
    });
}
/////////////////////////////////////////// app ///////////////////////////////////////
var landing_page = document.referrer || '/vn';

function getParam(p) {
  var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function removeParam(p) {
  var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
  return match ? window.location.search.replace(match[0], '') : window.location.search;
}
var _lang = getParam('lang');
var lang = document.referrer.split('/').slice(-2)[0] == 'vi' ? 'vi' : _lang ? _lang : '';
var _search = removeParam('next');
if (_search && _search[0] == '&') _search = _search.replace(/^\&/g, "?");
const after_test_link = decodeURIComponent(getParam('next') || (lang ? `/${lang}/elsa-pro` : '/elsa-pro')) + _search;
var lead_source = getParam('lead_source');
lead_source = lead_source ? lead_source : 'Assessment-Test';
var vw = Math.min(document.documentElement.clientWidth || 1000, window.innerWidth || 1000);
var circle_diameter = vw > 768 ? 180 : 144;
var score_to_level = function (score) {
  if (score < 56) return 'Beginner';
  if (56 <= score && score < 67) return 'Lower intermediate';
  if (67 <= score && score < 78) return 'Intermediate';
  if (78 <= score && score < 90) return 'Advanced';
  if (90 <= score) return 'Native';
}
userResponses = Array(sentences.length).fill(null);
userResults = Array(sentences.length).fill(null);
currentAudio = null;
play = function () {
  console.log(currentAudio);
  var url = URL.createObjectURL(currentAudio);
  var audio = new Audio(url)
  audio.onended = function () {
    app.speechActive = true;
    app.activeButton = '';
  };
  audio.play();

}
states = ['viewing', 'playing', 'finish', 'result'];
// waiting time
waiting = 0;
waitingInterval = null;
var app = new Vue({
  el: '#app',
  components: {
    RadialProgressBar: RadialProgressBar,
    ElsaSpeech: Vue.component('ElsaSpeech'),
  },
  data: {
    state: 'viewing',
    speechActive: true,
    activeButton: '',
    sentences: sentences,
    sIndex: 0,
    userResponses: userResponses,
    userResults: userResults,
    isActive: false,
    level: 'Advanced',
    native_score: 80,
    // circle config
    completedSteps: 80,
    totalSteps: 100,
    strokeWidth: 16,
    innerStrokeWidth: 16,
    strokeLinecap: 'round',
    startColor: '#16ABFF',
    stopColor: '#1CF0DB',
    innerStrokeColor: '#DAD8EB',
    timingFunc: 'linear',
    isClockwise: true,
    circle_diameter: circle_diameter,
    animateSpeed: 2000,
    isQuit: false,
  },
  filters: {
    charIndex: function (i) {
      return String.fromCharCode(97 + i);
    }
  },
  methods: {
    hearback: function () {
      if (this.activeButton != '') return;
      if (!this.userResponses[this.sIndex]) return;
      if (!currentAudio) {
        ConcatenateBlobs(this.userResponses[this.sIndex], 'audio/wav', function (resultingBlob) {
          currentAudio = resultingBlob;
          app.speechActive = false;
          app.activeButton = 'hearback';
          play();
        });
      } else {
        this.speechActive = false;
        this.activeButton = 'hearback';
        play();
      }
    },
    playback: function () {
      if (this.activeButton != '') return;
      this.speechActive = false;
      if (!this.sentences[this.sIndex].audio) this.sentences[this.sIndex].audio = new Audio(this.sentences[this.sIndex].audio_url);
      this.sentences[this.sIndex].audio.currentTime = 0;
      this.sentences[this.sIndex].audio.onended = function () {
        app.speechActive = true;
        app.activeButton = '';
      };
      this.activeButton = 'playback';
      this.sentences[this.sIndex].audio.play();
    },
    close: function () {
      if (this.isQuit) return;
      var _score = -1;
      var _result = {}
      if (this.userResults[this.sIndex] != null && this.userResults[this.sIndex].nativeness_score_percentage_user) {
        _score = this.userResults[this.sIndex].nativeness_score_percentage_user;
        _result = this.userResults[this.sIndex];
      }
      saveAction(this.sentences[this.sIndex].text, this.sIndex, _score, _result,
        this.userResults.map(item => item == null ? '' : item.nativeness_score_percentage_user), 'close');
    },
    quit: function () {
      this.close(); // make sure to call close function before quit
      this.isQuit = true; // prevent rerun close function onunload event
      scores = this.userResults.filter(item => item != null).map(item => item == null ? '' : item.nativeness_score_percentage_user).join(',');
      // window.location.href = after_test_link + ( after_test_link.match( /[\?]/g ) ? '&' : '?' ) + 'lead_source=' + lead_source + '&score=' + scores;
      payment.step1('one_year_credit', false, {
        utm_medium: 'Trial-section'
      });
      // window.location.href = landing_page;
    },
    startRecording: function () {
      currentRecordBlob = [];
      if (!mic_start_sound) mic_start_sound = new Audio('https://d1t11jpd823i7r.cloudfront.net/assessment/audio/mic_start_sound.mp3');
      mic_start_sound.currentTime = 0;
      mic_start_sound.play();
      this.state = 'playing';
    },
    stopRecording: function () {
      if (!mic_stop_sound) mic_stop_sound = new Audio('https://d1t11jpd823i7r.cloudfront.net/assessment/audio/mic_stop_sound.mp3');
      mic_stop_sound.currentTime = 0;
      mic_stop_sound.play();
      this.state = 'finish';
      this.$refs.speech.submit();
      waiting = 0;
      console.log('Start waiting ' + waiting);
      waitingInterval && clearInterval(waitingInterval);
      waitingInterval = setInterval(this.waitForResult, 1000);
    },
    force_try_again: function () {
      alert('Did you read the whole sentence? Please try again!');
      this.retry();
    },
    waitForResult: function () {
      console.log('waitting ... ')
      console.log(waiting);
      waiting += 1;
      if (this.state != 'finish') {
        console.log(this.state);
        clearInterval(waitingInterval);
      } else {
        if (waiting > 10) {
          console.log('wait too long')
          clearInterval(waitingInterval);
          this.force_try_again();
        }
      }
    },
    restart: function () {
      this.sIndex = 0;
      this.userResponses = Array(this.sentences.length).fill(null);
    },
    next: function () {
      if (this.activeButton != '') return;
      saveAction(this.sentences[this.sIndex].text, this.sIndex, this.userResults[this.sIndex].nativeness_score_percentage_user,
        this.userResults[this.sIndex], this.userResults.map(item => item == null ? '' : item.nativeness_score_percentage_user), 'continue');
      if (this.sIndex < this.sentences.length - 1) {
        this.sIndex++;
        this.retry();
      } else {
        // go some where
        scores = this.userResults.map(item => item.nativeness_score_percentage_user).join(',');
        var btnRetry = document.getElementById("btnretry");
        var btnContinue = document.getElementById("btncontinue");
        btnRetry.style.display = "none";
        btnContinue.innerText = "สมัครเรียน";

        let offset = $("#section-register").offset().top - ($("#header").outerHeight() || 0);
        if (!$("body").is(":animated")) {
          $("body,html").animate(
            {
              scrollTop: offset,
            },
            600
          );
        }

      }
    },
    prev: function () {
      if (this.sIndex > 0) {
        this.sIndex--;
        this.retry();
      }
    },
    retry: function () {
      if (this.activeButton != '') return;
      this.state = 'viewing';
      this.userResults[this.sIndex] = null;
    },
    scored: function (e) {
      if (e.score) {
        waitingInterval && clearInterval(waitingInterval);
        if (e.score.error === 'server_closing') {
          if (this.state == 'playing' || this.state == 'finish') this.force_try_again();
          return;
        }
        this.userResponses[this.sIndex] = currentRecordBlob;
        currentAudio = null;
        this.userResults[this.sIndex] = e.score
        this.native_score = this.userResults[this.sIndex].nativeness_score_percentage_user;
        this.level = score_to_level(this.native_score);
        this.completedSteps = Math.round(this.native_score);
        this.state = 'result';
        do_tracking(this.native_score);
      } else {
        alert('Server error! Sorry for this inconvinient, please try again');
        this.state = 'viewing';
      }
    },
    phonemeHighlighter() {
      let output = '';
      const strings = this.sentences[this.sIndex].text.trim();
      if (!this.userResults[this.sIndex]) return strings + '.';
      phonemes = this.userResults[this.sIndex].phonemes;
      var whiteSpace = [];
      for (var i = 0; i < strings.length; i++) {
        if (strings[i] === " ") whiteSpace.push(i - 1); // position of the character before space
      }
      strings.split();
      for (const score of phonemes) {
        for (let index = score.start_index; index <= score.end_index; index++) {
          output += '<span class="m-0 score-' + score.score_type + '">' + strings[index] + '</span>';
          if (whiteSpace.includes(index)) {
            output += '</span><span>&nbsp;</span><span>';
          }
        }
      }
      return output ? '<span>' + output + '.</span>' : strings + '.';
    },
    scrollToElement: function() {
      const el = document.getElementById('section-register');
      if (el) {
        el.scrollIntoView({behavior: 'smooth'});
      }
    }
  }
})
$(window).resize(function () {
  vw = Math.min(document.documentElement.clientWidth || 1000, window.innerWidth || 1000);
  circle_diameter = vw > 768 ? 180 : 144;
  app.circle_diameter = circle_diameter;
});
var do_tracking = function (score) {
  console.log('Tracking: score ' + score);
}
$(window).on("unload", app.close);
// load audio
for (let index = 0; index < sentences.length; index++) {
  sentences[index].audio = new Audio(sentences[index].audio_url);
}
var mic_start_sound = new Audio('https://d1t11jpd823i7r.cloudfront.net/assessment/audio/mic_start_sound.mp3');
var mic_stop_sound = new Audio('https://d1t11jpd823i7r.cloudfront.net/assessment/audio/mic_stop_sound.mp3');
